import React from "react";
import Top from "../components/Header";
import Desbloqueio from "../components/Desbloqueio";
import Bloco1 from "../components/Bloco1";
import Bloco2 from "../components/Bloco2";
import Bloco3 from "../components/Bloco3";
import Footer from "../components/Footer";
import ListarCartoes from "../components/FormDesbloqueio/ListarCartoes";
import AtualizarDados from "../components/FormDesbloqueio/AtualizarDados";

const Header: React.FC = () => {
  return (
    < >
      <Top />
      <Desbloqueio />
      <ListarCartoes />
      <AtualizarDados />
      <Bloco1 />
      <Bloco2 />
      <Bloco3 />
      <Footer />
    </>
  );
};

export default Header;
